import { GatewayNetworkModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/networks/models/outputs/gateway-network.model';
import { HeaderContext } from '@tanstack/react-table';
import { ReactNode } from 'react';

export interface NetworkListActionsHeaderProps
  extends HeaderContext<GatewayNetworkModel, unknown> {}

export const NetworkListActionsHeader =
  (): // props: NetworkListActionsHeaderProps,
  ReactNode => {
    // RENDER ////////////////////////////////////////////////////////////////////

    return null;
  };
